import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

/**
 * Base class pro kontrolu, že je vybrán druh ostatního RM, pokud nejde o semenný RM.
**/
@Injectable({
  providedIn: 'root'
})
export class DruhOstatnihoRmBaseValidator {

  protected semennyRm: number = 1;

  protected doValidation(druhRm: any, controlValue: any): ValidationErrors | null {
    if (druhRm != void 0 && druhRm != '' && druhRm.kod != this.semennyRm && (controlValue == void 0 || controlValue == '')) {
      return { 'druhOstatnihoRmRequired': 'Pokud se nejedná o semenný RM, je druh ostatního RM povinný.' };
    }
    return null;
  }
}
